import { useEffect, useRef, useCallback } from 'react';
import { api } from '@/api';

/**
 * Tracks a viewer's watch session — sends heartbeats every 30s.
 * Call with gameId and isLive flag. Returns nothing; runs as a side effect.
 */
const useViewTracking = (gameId, isLive = false) => {
  const sessionRef = useRef(null);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!gameId) return;

    const startSession = async () => {
      try {
        const res = await api.startView({ game_id: gameId, is_live: isLive });
        sessionRef.current = res.data.session_id;

        // Start heartbeat interval
        intervalRef.current = setInterval(async () => {
          if (sessionRef.current) {
            try {
              await api.sendHeartbeat({ session_id: sessionRef.current });
            } catch { /* silent */ }
          }
        }, 30000); // every 30 seconds
      } catch { /* silent - analytics shouldn't break the app */ }
    };

    startSession();

    return () => {
      // End session on unmount
      if (intervalRef.current) clearInterval(intervalRef.current);
      if (sessionRef.current) {
        api.endView({ session_id: sessionRef.current }).catch(() => {});
        sessionRef.current = null;
      }
    };
  }, [gameId, isLive]);
};

export default useViewTracking;
